<template>
  <div class="animated fadeIn" v-if="!loading">
    <basic-heading title="Receive Samples">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import StatisticTile from "@/components/shared/StatisticTile";
import SampleTable from "@/components/lab/sample/SampleTable";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SampleServerTable from "../../../components/lab/sample/SampleServerTable";

export default {
  name: "SamplePrep",
  components: {
    SampleServerTable,
    BasicHeading,
    StatisticTile,
    SampleTable,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    /**
     * Header button configuration
     */
    button_config() {
      return {
        buttons: [
          /*{
              icon: 'fa-list',
              linkto: '/samples',
              title: 'All samples',
              variant: 'success'
            }*/
        ],
      };
    },
  },
  // methods: {
  //   fetchPrepProcesses() {}
  // },
  // created() {
  //   this.loading = true;
  //   this.fetchPrepProcesses().then(() => {
  //     this.loading = false;
  //   });
  // }
};
</script>
